'use client'
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  gqlClient
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/qaList/listing.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getQaList = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(
      gql`
        query getQaList($lang: String, $limit: Int, $skip: Int, $where: QaListFilter) {
          qaListCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
            items {
              id
              title
              slug
              qaListCollection {
                items {
                  title
                  description {
                    json
                  }
                }
              }
            }
          }
        }
      `,
      __spreadProps(__spreadValues({}, props), { lang: getContentfulSafeLocale(props.lang) })
    );
    return res.qaListCollection.items[0];
  } catch (error) {
    throw new Exception({
      error,
      name: "getQaListException",
      context: { extra: __spreadValues({}, props) }
    });
  }
});
var useGetQaList = (props) => {
  return useQuery({
    queryKey: ["getQaList", props],
    queryFn: () => getQaList(props)
  });
};

export {
  useGetQaList
};
//# sourceMappingURL=chunk-AV6CPBTB.mjs.map